import gsap from 'gsap';

export default function initCategoryFilter() {
  const blogs = document.querySelectorAll('.blog');
  const blogFilter = document.querySelector('.blogs-list__filter');
  const blogFilterOptions = document.querySelectorAll('.filter-list__item');
  const totalBlogs = document.getElementById('totalBlogsFound');

  const selectFilter = document.getElementById('blogFilter');

  let activeLabel = '';
  let activeBlogs = 0;

  if (selectFilter)
    blogFilter.addEventListener("click", () => {
      selectFilter.classList.add('filter-list--active');
    });


  [].forEach.call(blogFilterOptions, option => {
    option.addEventListener("click", () => {

      [].forEach.call(blogFilterOptions, option => option.classList.remove('filter-list__item--active'));
      option.classList.add('filter-list__item--active');
      activeLabel = option.getAttribute('data-value');
      activeBlogs = 0;

      [].forEach.call(blogs, blog => {
        let blogLabels = JSON.parse(blog.getAttribute('data-labels'));

        if (blogLabels.indexOf(activeLabel) > -1) { // show
          let tl = gsap.timeline();
          tl.fromTo(blog, {autoAlpha: 0.2, y: '20px'}, {autoAlpha: 1, y: '0px'})
          blog.classList.remove("hide");
          blog.classList.add("display");
          activeBlogs++;
        } else { // hide
          let tl = gsap.timeline();
          tl.fromTo(blog, {autoAlpha: 1, y: '0px'}, {autoAlpha: 0.2, y: '20px'})       
          blog.classList.add("hide");
          blog.classList.remove("display");
        }
      })

      if(totalBlogs) {
        if (activeBlogs === 1) {
          activeBlogs = "Er is 1 bericht gevonden";
        } else if (activeBlogs === 0) {
          activeBlogs = "Er zijn geen berichten gevonden";
        } else {
          activeBlogs = "Er zijn " + activeBlogs + " berichten gevonden";
        }

        totalBlogs.innerHTML = activeBlogs;
      }

      selectFilter.classList.remove('filter-list--active');
    })
  })
}



